export interface StatItem {
  icon: string
  /**
   * The figure, where there is one.
   *
   * **Optional, and three of the four entries on `/about` leave it unset.** The row was
   * four counts — 7 areas of work, 4 phases, 3 social enterprises — and on 2026-09-21 three
   * of them became statements of what the Foundation is rather than counts of anything.
   * A count printed over "Christ Centred Community" is a figure invented to fill a slot,
   * which is the one thing no screen here does. The circle simply closes up without it.
   */
  number?: string
  txt: string
}

export interface StatsProps {
  items: StatItem[]
}

/**
 * The `.ul-stats` band — a row of small circles, each an icon and a word.
 *
 * **They used to be large.** Four of them filled a screen on `/about` at a quarter of the
 * container each, which is what a circle sized by its column does. They are capped now
 * (`sections/_stats.scss`) so the row reads as a summary between two sections rather than
 * as a section of its own, which is also what let it move below the story.
 */
export function Stats({ items }: StatsProps) {
  return (
    <div className="ul-stats ul-section-spacing">
      <div className="ul-container">
        <div className="ul-stats-wrapper wow animate__fadeInUp">
          <div className="row row-cols-md-4 row-cols-sm-3 row-cols-2 row-cols-xxs-1 ul-bs-row justify-content-center">
            {items.map((item) => (
              <div className="col" key={item.txt}>
                <div className="ul-stats-item">
                  <i className={`flaticon-${item.icon}`} />
                  {item.number && <span className="number">{item.number}</span>}
                  <span className="txt">{item.txt}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
